import { ActionTypes, ReduxAction } from './types';

import { Dispatch } from 'redux';
import { ReportModel } from '../../models/ReportModel';
import { CryptoService, ReportService } from '../../api';

export const getReports = () => async (dispatch: Dispatch<ReduxAction>) => {
  new ReportService().getReportTypes().then(result => {
    dispatch({
      type: ActionTypes.GET_REPORTS,
      payload: result.data,
    });
  });
};

export const printReports =
  (auftragIDs: number[], report: ReportModel) =>
  async (dispatch: (arg: { type: ActionTypes; payload: any }) => void) => {
    const protocol = location.protocol;
    const hostname = location.hostname;
    const port = location.port;
    new CryptoService()
      .getEncryptedIds(auftragIDs.toString())
      .then(async response => {
        let jasperUrl =
          protocol +
          '//' +
          hostname +
          (port !== '3000' ? ':' + port : '') +
          '/wdsjasperserver/jasperdon?';
        jasperUrl += 'reportNames=[' + report.reportFileName + ']';
        jasperUrl += '&ids=[todec,' + response.data + ']';

        window.open(jasperUrl);
      });
  };

/*
export const printReports =
  (auftragIDs: number[], report: ReportModel) =>
  async (dispatch: (arg: { type: ActionTypes; payload: any }) => void) => {
    const protocol = location.protocol;
    const hostname = location.hostname;
    const port = location.port;

    try {
      const response = await new CryptoService().getEncryptedIds(
        auftragIDs.toString()
      );

      let jasperUrl =
        protocol +
        '//' +
        hostname +
        (port !== '3000' ? ':' + port : '') +
        '/wdsjasperserver/jasperdon?';
      jasperUrl += 'reportNames=[' + report.reportFileName + ']';
      jasperUrl += '&ids=[todec,' + response.data + ']';

      // Hinzuf�gen eines label Parameters zur URL
      const label = report.label || 'Default Label';
      jasperUrl += `&label=${encodeURIComponent(label)}`;

      // PDF-Dokument laden
      const pdfResponse = await fetch(jasperUrl);
      if (!pdfResponse.ok) {
        throw new Error('Failed to load PDF');
      }

      // Blob des PDFs erstellen
      const pdfBlob = await pdfResponse.blob();

      // URL f�r das Blob erstellen
      const pdfUrlObject = URL.createObjectURL(pdfBlob);

      // Seite f�r das PDF erstellen
      const newWindow = window.open();
      if (newWindow) {
        // HTML f�r die eigene Seite im neuen Fenster erstellen
        newWindow.document.open();
        newWindow.document.write(`
          <!DOCTYPE html>
          <html lang="en">
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>${label}</title>
          </head>
          <body style="margin: 0;">
            <iframe src="${pdfUrlObject}" style="width: 100%; height: 100%; border: none;"></iframe>
          </body>
          </html>
        `);
        newWindow.document.close();
      } else {
        console.error('Failed to open new window');
      }
    } catch (error) {
      console.error('Error fetching encrypted IDs or loading PDF:', error);
    }
  };
*/
